import { render, staticRenderFns } from "./ContentInfoLinks.vue?vue&type=template&id=4da22364"
import script from "./ContentInfoLinks.vue?vue&type=script&lang=js"
export * from "./ContentInfoLinks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports